import { createContext, useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import api from "../api"; // 🔥 IMPORTANTE

export const AuthContext = createContext();

const SECRET_KEY = "cozimax_portal_cozimax_2026";

function encrypt(data) {
  const json = JSON.stringify(data);
  return CryptoJS.AES.encrypt(json, SECRET_KEY).toString();
}

function decrypt(data) {
  try {
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Erro ao descriptografar:", error);
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    async function loadUser() {
      const storedUser = sessionStorage.getItem("login");

      if (storedUser) {
        const userData = decrypt(storedUser);

        if (userData) {
          try {
            await api.get(`/portal/validar?codope=${userData.codope}`);
            setUser(userData);
          } catch (error) {
            const status = error?.response?.status;
            if (status === 401 || status === 403) {
              // Credencial inválida → força novo login
              sessionStorage.removeItem("login");
              setUser(null);
            } else {
              // API fora do ar ou erro de rede → mantém sessão
              setUser(userData);
            }
          }
        }
      }

      setLoadingAuth(false);
    }

    loadUser();
  }, []);

  function login(userData) {
    const encrypted = encrypt(userData);
    sessionStorage.setItem("login", encrypted);
    setUser(userData);
  }

  function logout() {
    sessionStorage.removeItem("login");
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, loadingAuth }}>
      {children}
    </AuthContext.Provider>
  );
}